var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStream({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04785 12.8116L7.95483 9.05313L11.2591 11.6425L14.0982 7.99035",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4122 4.43478C18.4397 4.43478 19.2727 3.60424 19.2727 2.57971C19.2727 1.55518 18.4397 0.72464 17.4122 0.72464C16.3847 0.72464 15.5518 1.55518 15.5518 2.57971C15.5518 3.60424 16.3847 4.43478 17.4122 4.43478Z",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4901 1.51691H5.45525C2.54827 1.51691 0.726562 3.58456 0.726562 6.49278V14.2995C0.726562 17.198 2.49982 19.256 5.45525 19.256H13.7886C16.6955 19.256 18.5173 17.2077 18.5173 14.2995V7.53621",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStream);
export default __webpack_public_path__ + "static/media/stream.5542073d9b1650541cfd22e060786341.svg";
export { ForwardRef as ReactComponent };